import apiClient from './apiClient';

export const getMilkings = async () => {
    try {
        const response = await apiClient.get('/milking/');
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const getMilkingById = async (id) => {
    try {
        const response = await apiClient.get(`/milking/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// export const getMilkingsByAnimalId = async (animalId) => {
//     try {
//         const response = await apiClient.get(`/milking/animal/${animalId}`);
//         return response.data;
//     } catch (error) {
//         throw error.response?.data || error.message;
//     }
// };

export const getMilkingsByAnimalId = async (animalId, params = {}) => {
    try {
        const response = await apiClient.get(`/milking/animal/${animalId}`, { params });
        return response.data;
    } catch (error) {
        // If the backend returns 404 for "no records", treat as empty array
        if (error?.response?.status === 404) return [];
        throw error.response?.data || error.message;
    }
};

export const createMilking = async (milkingData) => {
    try {
        const response = await apiClient.post('/milking/create', milkingData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const updateMilking = async (id, milkingData) => {
    try {
        const response = await apiClient.put(`/milking/${id}`, milkingData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const deleteMilking = async (id) => {
    try {
        const response = await apiClient.delete(`/milking/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Paginated
export const getMilkingsByAnimalIdPaginated = async (animalId, params = {}) => {
    try {
        const res = await apiClient.get(`/milking/animal/${animalId}/paginated`, { params });
        return res.data; // { items, total, page, page_size }
    } catch (error) {
        if (error?.response?.status === 404) {
            return { items: [], total: 0, page: params.page || 1, page_size: params.page_size || 25 };
        }
        throw error.response?.data || error.message;
    }
};

// CSV export
export const exportMilkingsCsv = async (animalId, params = {}) => {
    const res = await apiClient.get(`/milking/animal/${animalId}/export`, {
        params,
        responseType: 'blob'
    });
    const blob = new Blob([res.data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `milking_animal_${animalId}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
};

export const getAnimalMilkingSummary = async (animalId, params = {}) => {
    try {
        const res = await apiClient.get(`/milking/animal/${animalId}/summary`, { params });
        return res.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const getMilkDashboardSummary = async (params = {}) => {
    try {
        const res = await apiClient.get('/milking/summary', { params });
        return res.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const getMilkTrends = async (params = {}) => {
    try {
        const res = await apiClient.get('/milking/trends', { params });
        return res.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const getMilkPrices = async () => {
    try {
        const res = await apiClient.get('/milk-prices/');
        return Array.isArray(res.data) ? res.data : [];
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const getMilkPricesPaginated = async (params = {}) => {
    try {
        const res = await apiClient.get('/milk-prices/paginated', { params });
        return res.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const exportMilkPricesCsv = async () => {
    const res = await apiClient.get('/milk-prices/export', {
        responseType: 'blob'
    });
    const blob = new Blob([res.data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'milk_prices.csv';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
};

export const createMilkPrice = async (payload) => {
    try {
        const res = await apiClient.post('/milk-prices/', payload);
        return res.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const updateMilkPrice = async (priceId, payload) => {
    try {
        const res = await apiClient.put(`/milk-prices/${priceId}`, payload);
        return res.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const deleteMilkPrice = async (priceId) => {
    try {
        await apiClient.delete(`/milk-prices/${priceId}`);
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const getMilkSales = async (params = {}) => {
    try {
        const res = await apiClient.get('/milk-sales/', { params });
        return Array.isArray(res.data) ? res.data : [];
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const getMilkSalesPaginated = async (params = {}) => {
    try {
        const res = await apiClient.get('/milk-sales/paginated', { params });
        return res.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const exportMilkSalesCsv = async (params = {}) => {
    const res = await apiClient.get('/milk-sales/export', {
        params,
        responseType: 'blob'
    });
    const blob = new Blob([res.data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'milk_sales.csv';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
};

export const createMilkSale = async (payload) => {
    try {
        const res = await apiClient.post('/milk-sales/', payload);
        return res.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const updateMilkSale = async (saleId, payload) => {
    try {
        const res = await apiClient.put(`/milk-sales/${saleId}`, payload);
        return res.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const deleteMilkSale = async (saleId) => {
    try {
        await apiClient.delete(`/milk-sales/${saleId}`);
    } catch (error) {
        throw error.response?.data || error.message;
    }
};